const oidc = {
    logout_success: 'Sie haben sich erfolgreich abgemeldet.',
};
export default oidc;
